import React from 'react'

function Espacio({...r}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"{...r}>
      <path
        stroke="#00033A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M20.19 17.83H7.06L9.15 3.02h8.95l2.09 14.81zm-6.56 42.92V18.09m-4 42.66h8m28.28-21.83c5.9-.47 9.8-2.65 10.37-9.78.18-2.23.31-4.5.44-6.7.34-5.73.66-11.14 1.63-13.45.16-.39.06-.81-.25-1.09a.966.966 0 00-1.13-.12c-1.06.59-2.92 1.97-3.53 4.56-.53 2.24-.83 4.48-1.13 6.66-.99 7.26-1.78 12.99-9.64 13.87-9.64 1.08-14.16 2.09-15.5 5.22-.19.45-.1.96.25 1.31a1.251 1.251 0 001.35.28c1.27-.52 3.93-1.08 9.43-.79l1.88.09 5.83-.06zm-5.88.57l-7.96 21.35m14.56-21.35l7.96 21.35"
      ></path>
      <path
        stroke="#00033A"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M38.16 44.61l14.82 11.47m-4.41-11.47L33.75 56.08"
      ></path>
      <path
        fill="#126FFF"
        d="M32.93 24.93c-.28 0-.5-.22-.5-.5 0-3.09-2.51-5.6-5.6-5.6-.28 0-.5-.22-.5-.5s.22-.5.5-.5c3.09 0 5.6-2.51 5.6-5.6 0-.28.22-.5.5-.5s.5.22.5.5c0 3.09 2.51 5.6 5.6 5.6.28 0 .5.22.5.5s-.22.5-.5.5c-3.09 0-5.6 2.51-5.6 5.6 0 .28-.23.5-.5.5zm9.71-9.41c-.28 0-.5-.22-.5-.5 0-2.39-1.94-4.33-4.33-4.33-.28 0-.5-.22-.5-.5s.22-.5.5-.5c2.39 0 4.33-1.94 4.33-4.33 0-.28.22-.5.5-.5s.5.22.5.5c0 2.39 1.94 4.33 4.33 4.33.28 0 .5.22.5.5s-.22.5-.5.5c-2.39 0-4.33 1.94-4.33 4.33 0 .28-.22.5-.5.5z"
      ></path>
    </svg>
  )
}

export default Espacio